import { FieldError } from "../FieldError";
import { Label } from "../../../../components/ui/label";
import { Input } from "../../../../components/ui/input";

export function Fein({ control, register }) {
  return (
    <div className="space-y-2">
      <Label htmlFor="fein">FEIN (Federal Employee Identification Number)</Label>
      <Input
        id="fein"
        placeholder="Enter..."
        {...register("step2.fein")}
      />
      <FieldError name="step2.fein" step="step2" control={control} />
    </div>
  );
}